import React, { Component } from "react";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import PropTypes from "prop-types";

// 8 levels
const bars = [
	{ bg: "#82A652", color: "#fff", incomeCode: "R1" },
	{ bg: "#D3D653", color: "#000", incomeCode: "R2" },
	{ bg: "#F3EC3A", color: "#000", incomeCode: "R3" },
	{ bg: "#EEBD5E", color: "#000", incomeCode: "R4" },
	{ bg: "#E2A54A", color: "#000", incomeCode: "R5" },
	{ bg: "#D7703D", color: "#fff", incomeCode: "R6" },
	{ bg: "#D25537", color: "#fff", incomeCode: "R7" },
	{ bg: "#B63951", color: "#fff", incomeCode: "R8" },
];

const WIDTH_PORCION = 100 / (bars.length + 1);
const MIN_WIDTH = 170

export default class IncomeIndicator extends Component {
	constructor(props) {
		super(props);
		this.state = {
			startIndex: 0,
			lastIndex: 8,
		};
	}

	componentDidMount() {
		// Resto 2 por el ancho del indicador
		this.props.onWidthChange(MIN_WIDTH - 5)
	}

	render() {
		return (
			<div
				className="pull-right"
				style={{
					minWidth: MIN_WIDTH + "px",
				}}
			>
				{[...bars]
					.slice(this.state.startIndex, this.state.lastIndex)
					.map((bar, idx) => {
						return (
							<IncomeIndicatorBar
								key={idx}
								bg={bar.bg}
								color={bar.color}
								width={
									100 -
									(idx + this.state.startIndex) * WIDTH_PORCION
								}
								label={bar.incomeCode}
								legend={
									(this.props.incomePredictorRangoList.find(e => e.rango === bar.incomeCode) || {}).texto
								}
								isCurrent={
									bar.incomeCode === this.props.incomePredictor
								}
							/>
						);
					})}
			</div>
		);
	}
}

IncomeIndicator.propTypes = {
	incomePredictor: PropTypes.string,
	incomePredictorRango: PropTypes.string,
	incomePredictorRangoList: PropTypes.arrayOf(PropTypes.string),
	onWidthChange: PropTypes.func,
};

const IncomeIndicatorBar = ({ bg, color, width, label, legend, isCurrent }) => {
	const barStyle = {
		width: "0",
		height: "0",
		borderStyle: "solid",
		borderWidth: "12px 0 12px 24px",
		borderColor: `transparent transparent transparent ${bg}`,
	};

	const component = (
		<div
			style={{
				display: "flex",
				height: "24px",
				width: width + "%",
				position: "relative",
				margin: "2px 0",
			}}
		>
			<div
				style={{
					width: "80%",
					height: "100%",
					backgroundColor: bg,
					paddingLeft: "1rem",
					lineHeight: "24px",
					color,
				}}
			>
				<strong>{label}</strong>
				{isCurrent && <IncomeIndicatorBarMark />}
			</div>
			<div style={barStyle} />
		</div>
	);

	return withTooltip(component, legend);
};

const IncomeIndicatorBarMark = () => {
	const barStyle = {
		width: "0px",
		height: "0px",
		borderTop: "8px solid transparent",
		borderBottom: "8px solid transparent",
		borderLeft: "8px solid rgba(0,0,0,0.8)",
	};

	return (
		<div
			style={{
				position: "absolute",
				right: "calc(100% + 2px)",
				top: "4px",
			}}
		>
			<div style={barStyle} />
		</div>
	);
};

function withTooltip(component, text) {
	return (
		<OverlayTrigger
			placement="left"
			overlay={<Tooltip id="bar-tooltip">{text}</Tooltip>}
		>
			{component}
		</OverlayTrigger>
	);
}



// WEBPACK FOOTER //
// ./src/scenes/personas/components/personas-detalle/components/panel-veraz/components/IncomeIndicator.js